import { renderToStaticMarkup } from 'react-dom/server'
import DOMPurify from 'dompurify'
import parse from 'html-react-parser'

import ReportMapper from './ReportMapper'


function Template({ insurerCode, formCode, data }) {

    // Get report component for the template type specified
    const component = <ReportMapper insurerCode={insurerCode} formCode={formCode} data={data} />
    
    // Render component to html
    const componentHtml = renderToStaticMarkup(component)

    // Remove any unsafe html
    const cleanHtml = DOMPurify.sanitize(componentHtml, {
        USE_PROFILES: { html: true }
    })

    return (
        <html>
            <body>
                {parse(cleanHtml)}
            </body>
        </html>
    )
}

export default Template